module.exports = __webpack_public_path__ + "static/media/people-house.403cf12f.jpg";